import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchProducts = createAsyncThunk('productsSlice/fetchProducts', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?products`)
    const data = await res.json()
    return data;
})

const productsSlice = createSlice({
    initialState: {
        products: [],
        loading: false,
        error: null,
        status: 'idle',
    },
    name: 'productsSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.pending, (state) => {
                state.loading = true;
                state.status = 'loading';
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.loading = false;
                state.status = 'succeeded';
                state.products = action.payload;
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.loading = false;
                state.status = 'failed';
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = productsSlice.actions;

export default productsSlice.reducer;